import React from "react";
import {
	Modal,
	Box,
	Typography,
	Grid,
	Paper,
	Divider,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: { xs: "90%", sm: "600px" },
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: 4,
	p: 4,
	maxHeight: "90vh",
	overflowY: "auto",
};

const ShipmentInfoModal = ({ open, handleClose, shipment }) => {
	if (!shipment) return null;

	const {
		_id,
		trackingNumber,
		shipmentStatus,

		// originAddress,
		// destinationAddress,
		// pickupDate,
		estimatedDeliveryDate,
		// packages,
		shippingCost,
		// labelsUrl,
	} = shipment;

	const originAddress = `${shipment?.fromCity} ${shipment?.fromCountry}`;
	const destinationAddress = `${shipment?.toCity} ${shipment?.toCountry}`;
	const pickupDate = shipment?.pickUpdate;
	const packages = shipment?.shipmentList;
	const shipmentId = shipment?._id;

	console.log(shipment);

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="shipment-details-title">
			<Box sx={style}>
				{/* Close Button */}
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>

				{/* Title */}
				<Typography
					id="shipment-details-title"
					variant="h5"
					component="h2"
					sx={{ fontSize: "1.1rem" }}
					gutterBottom>
					Shipment Details
				</Typography>

				{/* Basic Info */}
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Shipment ID
						</Typography>
						<Typography variant="body1" sx={{ fontSize: "0.8rem" }}>
							{shipmentId}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Tracking Code
						</Typography>
						<Typography variant="body1" sx={{ fontSize: "0.8rem" }}>
							{trackingNumber}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Status
						</Typography>
						<Typography variant="body1">{shipmentStatus}</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Carrier
						</Typography>
						<Typography variant="body1">Direct Cargo Trust </Typography>
					</Grid>
				</Grid>

				<Divider sx={{ my: 2 }} />

				{/* Addresses */}
				<Typography variant="h6" sx={{ fontSize: "1.1rem" }} gutterBottom>
					Addresses
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Origin
						</Typography>
						<Typography variant="body2">{originAddress}</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Destination
						</Typography>
						<Typography variant="body2">{destinationAddress}</Typography>
					</Grid>
				</Grid>

				{/* Dates */}
				<Divider sx={{ my: 2 }} />
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Pickup Date:
						</Typography>
						<Typography variant="body2">{shipment?.pickUpDate}</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Estimated Delivery
						</Typography>
						<Typography variant="body2">{estimatedDeliveryDate}</Typography>
					</Grid>
				</Grid>

				{/* Packages */}
				<Divider sx={{ my: 2 }} />
				<Typography variant="h6" sx={{ fontSize: "1.1rem" }} gutterBottom>
					Packages
				</Typography>
				{shipment?.shipmentList.map((pkg, index) => (
					<Paper key={index} sx={{ p: 2, mb: 2 }}>
						<Typography variant="subtitle2" sx={{ mb: "0.5rem" }}>
							Package {index + 1}
						</Typography>
						<Typography sx={{ fontSize: "0.9rem" }}>
							Dimensions {"(cm)"}:
						</Typography>
						<Typography sx={{ fontSize: "0.8rem" }}>
							L:{pkg?.itemLength} x W:{pkg?.itemWidth} x H:{pkg?.itemHeight}
						</Typography>
						<Divider sx={{ my: "0.4rem" }} />
						<Typography>Weight: {pkg.itemWeight} kg</Typography>
						<Divider sx={{ my: "0.4rem" }} />

						<Typography>Description:</Typography>
						<Typography> {pkg?.itemDescription}</Typography>
					</Paper>
				))}

				{/* Cost and Labels */}
				<Divider sx={{ my: 2 }} />
				<Grid container spacing={2}>
					{/* <Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" color="textSecondary">
							Description:{shipment?.itemDescription}
						</Typography>
						<Typography variant="body1">{shipment?.itemDescription}</Typography>
					</Grid> */}
					<Grid item xs={12} sm={6}>
						{/* <Typography variant="subtitle2" color="textSecondary">
							Labels
						</Typography> */}
						{/* <a href={labelsUrl} target="_blank" rel="noopener noreferrer">
							Download Label
						</a> */}
						{/* later */}
					</Grid>
				</Grid>
			</Box>
		</Modal>
	);
};

export default ShipmentInfoModal;
